import React from 'react';
import {Link} from 'react-router-dom';

function HyperLink({url, className = '', children, target, clickEvent = () => {}, id}) {
    const targetType = target || ((url && url.includes('maxis.com.my')) || url === '#' ? '_self' : '_blank');
    const handleClick = () => {
        id ? clickEvent(id) : clickEvent();
    };
    return (
        <Link
            className={`hyperlink link-blue ${className}`}
            onClick={handleClick}
            to={url}
            target={targetType}
            rel='noopener noreferrer'
        >
            {children}
        </Link>
    );
}
export default HyperLink;
